import { FC } from "react";
import { Button } from "components/Button";
import { domain } from "utils/domain";

const NotFoundPage: FC = () => {
  return (
    <div style={{ minHeight: "100vh" }} className="f-center f-column center">
      <h1 className="text-45 bolder mb-8 l-s-2">404</h1>
      <h2 className="mb-8">Page not found</h2>
      <Button
        type="text"
        color="none"
        className="info"
        textSize="large"
        size="large"
      >
        <a href={window.location.protocol + "//" + domain}>Go Home</a>
      </Button>
    </div>
  );
};

export default NotFoundPage;
